import { config } from 'cfg'

export const OSM_ENDPOINTS = {
  osm: () => `${config.apiBaseUrl}/osm`,
  import: () => `${OSM_ENDPOINTS.osm()}/import`,
  ways: (
    minLon: number,
    minLat: number,
    maxLon: number,
    maxLat: number,
    excludeNetworkId?: number
  ) => {
    const params = new URLSearchParams({
      minLon: String(minLon),
      minLat: String(minLat),
      maxLon: String(maxLon),
      maxLat: String(maxLat)
    })
    if (excludeNetworkId != null) params.set('excludeNetworkId', String(excludeNetworkId))
    return `${OSM_ENDPOINTS.osm()}/ways?${params.toString()}`
  }
}
